import React from "react";
export var FileUpload = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement("input", {
    "aria-label": "Select File",
    id: props.idTag1,
    type: props.type,
    name: props.name,
    onChange: props.onChangeHandler,
    onClick: function (event) {
      return event.target.value = null;
    },
    ref: ref,
    style: {
      display: "none"
    }
  });
});